import request from '@/utils/request'


// 查询搜索页推荐词列表
export function listSearchRecommendWord(query) {
  return request({
    url: '/search/search/recommend/word/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询搜索页推荐词分页
export function pageSearchRecommendWord(query) {
  return request({
    url: '/search/search/recommend/word/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询搜索页推荐词详细
export function getSearchRecommendWord(data) {
  return request({
    url: '/search/search/recommend/word/detail',
    method: 'get',
    params: data
  })
}

// 新增搜索页推荐词
export function addSearchRecommendWord(data) {
  return request({
    url: '/search/search/recommend/word/add',
    method: 'post',
    data: data
  })
}

// 修改搜索页推荐词
export function updateSearchRecommendWord(data) {
  return request({
    url: '/search/search/recommend/word/edit',
    method: 'post',
    data: data
  })
}

// 删除搜索页推荐词
export function delSearchRecommendWord(data) {
  return request({
    url: '/search/search/recommend/word/delete',
    method: 'post',
    data: data
  })
}
